export const INITIAL_STATE = {
    b2c_meeting_benefits: {},
    store_visit_benefits: {},
    meeting_documents: {},
    test_drive_info: {}
};

const actionHandlers = {
    SAVE_B2C_MEETING_DATA: (state, action) => ({
        ...state,
        b2c_meeting_benefits: action.data.store_test_drive_benefits,
        store_visit_benefits: action.data.store_visit_benefits,
        test_drive_info: action.data.home_test_drive_info,
        meeting_documents: action.data.test_drive_documents,
        store_visit_meeting_documents: action.data.store_visit_documents,
        operating_details: action.data.operating_details || null
    })
};

export default (state = INITIAL_STATE, action) => {
    const handler = actionHandlers[action.type];

    return handler ? handler(state, action) : state;
};
